// app/javascript/controllers/cancel_account_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "grid", 'nextButton']

  toggle(event) {
    // Update styles
    this.containerTarget.classList.remove("bg-gray-200")
    this.containerTarget.classList.add("bg-white")
    if (this.hasGridTarget) {
      this.gridTarget.classList.remove("bg-gray-200");
      this.gridTarget.classList.add("bg-gray-50");
    }

    const container = this.containerTarget

    // Hide the `.text-center.mb-4` inside the correct container
    const messageSection = container.querySelector(".text-center.mb-4")
    if (messageSection) {
      messageSection.style.display = "none"
    }
    this.nextButtonTarget.classList.remove("hidden")
  }
}
